import { Erro } from "../StatusIcones/erro";
import { Finalizado } from "../StatusIcones/finalizado";
import { Indisponivel } from "../StatusIcones/indisponivel";
import { Processando } from "../StatusIcones/processando";
import { EtapaGerenciarEmplacamentosEnum } from "../../enums/EtapaGerenciarEmplacamentos.enum";
import { StatusEtapaGerenciarEmplacamentosEnum } from "../../enums/StatusEtapaGerenciarEmplacamentos.enum";
import { Pagar } from "../StatusIcones/pagar";
import { HttpResponse } from "_services/api/HttpResponse";
import { IListarEmplacamentosPR } from "../../Interfaces/IListarEmplacamentosPR";
import { useEffect } from "react";

interface HandleStatusPagarIpvaProps {
  etapa: EtapaGerenciarEmplacamentosEnum;
  status: StatusEtapaGerenciarEmplacamentosEnum;
  pagarIpva: (id: number) => Promise<HttpResponse>;
  idProcesso: number;
  dados: IListarEmplacamentosPR[];
  setDados: (dados: IListarEmplacamentosPR[]) => void;
  setTooltipLeft: (left: number) => void;
  setTooltipTop: (top: number) => void;
  setTooltipConteudo: (conteudo: string | JSX.Element) => void;
  setTooltipWidth: (width: number) => void;
  setShowTooltip: (show: boolean) => void;
  abrirModalPularProximaEtapa: (
    id: number,
    mensagemErro: string,
    etapaComErro: EtapaGerenciarEmplacamentosEnum
  ) => void;
  mensagemErro: string;
  codigoDeBarras: NullableString;
  listar: () => void;
}
export function HandleStatusPagarIpva({
  etapa,
  status,
  pagarIpva,
  idProcesso,
  dados,
  setDados,
  setTooltipLeft,
  setTooltipTop,
  setTooltipConteudo,
  setTooltipWidth,
  setShowTooltip,
  abrirModalPularProximaEtapa,
  mensagemErro,
  codigoDeBarras,
  listar,
}: HandleStatusPagarIpvaProps) {
  const handleStatus = (
    status: StatusEtapaGerenciarEmplacamentosEnum,
    mensagem?: string
  ) => {
    dados.forEach((processo) => {
      if (processo.id == idProcesso) {
        processo.statusEtapa = status;
        processo.etapa = EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA;

        if (mensagem) {
          processo.observacao = mensagem;
        }
      }
    });
    setDados(dados);
  };

  const onClick = async () => {
    handleStatus(StatusEtapaGerenciarEmplacamentosEnum.PROCESSANDO);
    setDados([...dados]);
    const { hasErro, data } = await pagarIpva(idProcesso);

    setShowTooltip(false);
    setTooltipLeft(0);
    setTooltipTop(0);
    setTooltipConteudo("");

    if (hasErro) {
      handleStatus(
        StatusEtapaGerenciarEmplacamentosEnum.ERRO,
        data?.message ?? null
      );
      return;
    }

    if (data?.recarregar) {
      await listar();
      return;
    }

    handleStatus(StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO);
  };

  const etapasPosteriores = [
    EtapaGerenciarEmplacamentosEnum.FINALIZAR_PROCESSO,
  ];

  const etapasMuitoAnteriores = [
    EtapaGerenciarEmplacamentosEnum.ESCOLHER_PLACA,
    EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO,
    EtapaGerenciarEmplacamentosEnum.PAGAR_TAXA,
    EtapaGerenciarEmplacamentosEnum.APROPRIAR_PROCESSO,
    EtapaGerenciarEmplacamentosEnum.EMITIR_LICENCIAMENTO,
    EtapaGerenciarEmplacamentosEnum.GERAR_PROCESSO_DIGITAL,
  ];

  if (
    !codigoDeBarras ||
    !etapa ||
    (etapa == EtapaGerenciarEmplacamentosEnum.SOLICITAR_PLACA &&
      status != StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO) ||
    etapasMuitoAnteriores.includes(etapa)
  ) {
    return <Indisponivel />;
  }

  if (
    (etapa && etapasPosteriores.includes(etapa)) ||
    (etapa == EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA &&
      status == StatusEtapaGerenciarEmplacamentosEnum.FINALIZADO)
  ) {
    return <Finalizado />;
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA &&
    status == StatusEtapaGerenciarEmplacamentosEnum.ERRO
  ) {
    return (
      <Erro
        onClick={() =>
          abrirModalPularProximaEtapa(
            idProcesso,
            mensagemErro,
            EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA
          )
        }
      />
    );
  }

  if (
    etapa == EtapaGerenciarEmplacamentosEnum.PAGAR_IPVA &&
    status == StatusEtapaGerenciarEmplacamentosEnum.PROCESSANDO
  ) {
    return (
      <Processando
        setTooltipLeft={setTooltipLeft}
        setTooltipTop={setTooltipTop}
        setTooltipConteudo={setTooltipConteudo}
        setTooltipWidth={setTooltipWidth}
        setShowTooltip={setShowTooltip}
      />
    );
  }

  return <Pagar acao={onClick} />;
}
